import React, { ReactNode, useCallback, useState } from 'react';
import { Drawer, Layout } from 'antd';
import Navbar, { NavbarProps } from '../Navbar';
import Toolbar, { ToolbarProps } from '../Toolbar';
import IconHamburgerNew from '../Icons/IconHamburgerNew';
import './Header.less';

const { Sider } = Layout;

export type HeaderProps = {
  logo?: ReactNode;
  navigation?: NavbarProps['navigation'];
  toolbar?: ToolbarProps['items'];
  current?: any;
  setCurrent?: any;
  onClick?: any;
  onVisiblityChange?: (state: boolean) => {};
  onOpenChange?: any;
  height?: string;
  width?: string;
  collapsible: boolean;
  defaultCollapsed: boolean;
};

const Header: React.FC<HeaderProps> = ({
  logo,
  navigation,
  toolbar,
  current,
  setCurrent,
  onClick,
  onOpenChange,
  height,
  width = '300px',
  collapsible = true,
  defaultCollapsed = false,
  onVisiblityChange,
}) => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  const handleOpenDrawer = useCallback(() => {
    setDrawerVisible(true);
  }, []);

  const handleCloseDrawer = useCallback(() => {
    setDrawerVisible(false);
  }, []);

  const handleCollapseMenu = useCallback(() => {
    setCollapsed(!collapsed);
    onVisiblityChange(collapsed);
  }, [collapsed]);

  return (
    <>
      <Sider
        className="t-sider"
        trigger={null}
        collapsible={collapsible}
        collapsed={collapsed}
        width={width}
      >
        <div className="t-header t-header-vertical">
          <div className="t-logo-wrapper">
            <div className="t-logo">{logo}</div>
            {collapsible && (
              <div className="t-switcher" onClick={handleCollapseMenu}>
                <IconHamburgerNew size="md" />
              </div>
            )}
          </div>
          <nav>
            <Navbar
              mode="inline"
              navigation={navigation}
              setCurrent={setCurrent}
              current={current}
              onClick={onClick}
              height={height}
              onOpenChange={onOpenChange}
            />
          </nav>
          <Toolbar mode="inline" items={toolbar} onClick={onClick} />
        </div>
      </Sider>
      <nav className="t-drawer-wrapper">
        <div className="t-logo-wrapper">
          <div className="t-toggle-button" onClick={handleOpenDrawer}>
            <IconHamburgerNew size="xl" />
          </div>
          <div className="t-logo">{logo}</div>
        </div>
        <Drawer
          title={logo}
          placement="left"
          visible={drawerVisible}
          onClose={handleCloseDrawer}
          className="t-drawer"
        >
          <Navbar
            mode="vertical"
            // onClick={handleCloseDrawer}
            navigation={navigation}
            setCurrent={setCurrent}
            current={current}
            onClick={onClick}
            height={height}
            onOpenChange={onOpenChange}
          />
          <Toolbar mode="vertical" items={toolbar} onClick={onClick} />
        </Drawer>
      </nav>
    </>
  );
};

export default Header;
